module.exports = __webpack_public_path__ + "img/flag_refund.0088ef90.png";